export type {
    TMenuStructure,
    TMenuResponse,
    IMenuResponseItem,
    IMenuStructureItem,
    IMenuSliceState,
} from './menu-slice-types';

export {EMenuItemType} from './menu-slice-types';

export {
    selectSelectedMenusIds,
    selectIsMenuOpen,
    selectMenuStructureObject,
    selectMenuItemByEntityName,
    selectMenuStructure,
    selectMenuStructureIdMap,
    selectMenuMeta,
    selectMenuOpenId,
    selectMenuSearchLine,
} from './menu-slice-selectors';

export { // todo: вынести из слайса
    generateRoute,
    isItemTypeTabsWithReferences,
    menuIconResolver,
} from './menu-slice-utils';
